import { BASE_URL, GET, INCIDENT_LIST, PAGE_SIZE } from "../constants";
import { statusParsing, jsonParsing } from "../utils";
import { getAccessToken } from "../../authActions/authActions";

export const fetchIncidentList = async (next,status="",uniqueCustomerRefId="",orderBy="",searchKeyValue="",pageSize=PAGE_SIZE) => {
  const token = await getAccessToken();
  let url = `${BASE_URL}${INCIDENT_LIST}`;

let array = [
  {
    key:"next",
    value:next
  },
  {
    key:"status",
    value:encodeURIComponent(status)
  },
  {
    key:"searchKey",
    value:encodeURIComponent(searchKeyValue)
  },
  {
    key:"uniqueCustomerRefId",
    value:encodeURIComponent(uniqueCustomerRefId)
  },
  {
    key:"orderBy",
    value:encodeURIComponent(orderBy)
  },
  {
    key:"pageSize",
    value:encodeURIComponent(pageSize)
  },
]  

let queryString=``;
array.forEach((item)=>{
  if(item.value){
    if(queryString){
      queryString=queryString+`&${item.key}=${item.value}`
    }else{
      queryString=`${item.key}=${item.value}`
    }
  }
})
if(queryString){
  url=`${url}?${queryString}`;
  url = url.replace ("filter=&", "");
}
  return fetch(url, {
    method: GET,
    headers: {
      "Content-Type": "application/json",
      userAuth: `bearer ${token}`,
    },
  })
    .then(statusParsing)
    .then(jsonParsing);
};
